<template>
  <b-card
    v-if="isVisible"
    :title="$t('message.addressSearchForm.title')"
    class="rounded-0">
    <b-form @submit.prevent="onSubmit">
      <b-form-row class="mt-4">
        <b-col>
          <b-form-group
            class="mt-4"
            :state="this.isInvalidPlace ? false : null"
            :invalid-feedback="$t('error.addressSearchForm.autocomplete')">
            <vue-google-autocomplete
              :id="'autocomplete_address'"
              :class="isInvalidPlace ? 'form-control rounded-0 is-invalid' : 'form-control rounded-0'"
              :placeholder="$t('message.addressSearchForm.input.placeholder.autocomplete')"
              v-on:placeChanged="onPlaceChanged"
              v-on:noPlaceFound="onNoPlaceFound">
            </vue-google-autocomplete>
          </b-form-group>
        </b-col>
      </b-form-row>
      <b-form-row class="mt-4">
        <b-button
          type="submit"
          variant="primary"
          class="ml-auto rounded-0"
          :disabled="!isValidForm">
          {{ $t('message.addressSearchForm.btn.submit') }}
        </b-button>
      </b-form-row>
    </b-form>
  </b-card>
</template>

<script>
  import VueGoogleAutocomplete from '@/components/common/VueGoogleAutocomplete'
  export default {
    components: {
      VueGoogleAutocomplete
    },
    computed: {
      addresses () {
        return this.$store.getters.addresses
      },
      isContactPerson () {
        const currentUser = this.$store.getters.currentUser
        if (Object.keys(currentUser).length > 0) {
          const rolesContactPerson = currentUser.roles.filter(role => role.roleOfUser === 'CONTACT_PERSON')
          if (rolesContactPerson.length > 0) {
            return true
          }
        }
        return false
      },
      isPolicyHolder () {
        const currentUser = this.$store.getters.currentUser
        if (Object.keys(currentUser).length > 0) {
          const rolesPolicyHolder = currentUser.roles.filter(role => role.roleOfUser === 'POLICY_HOLDER')
          if (rolesPolicyHolder.length > 0) {
            return true
          }
        }
        return false
      },
      isVisible () {
        if (this.isPolicyHolder) {
          return true
        } else if (this.isContactPerson && this.addresses.length === 0) {
          return true
        }
      }
    },
    data () {
      return {
        address: null,
        isInvalidPlace: false,
        isValidForm: false
      }
    },
    methods: {
      onNoPlaceFound () {
        this.isInvalidPlace = true
        this.isValidForm = false
      },
      onPlaceChanged (place) {
        this.address = {
          street: place.route,
          streetNumber: place.street_number,
          postalCode: place.postal_code,
          city: place.locality,
          country: place.country
        }
        this.isInvalidPlace = false
        this.isValidForm = true
      },
      onSubmit () {
        if (this.address) {
          this.$store.commit('setCurrentAddress', this.address)
          this.$router.push({ path: 'addresses/confirm' })
        }
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/address/AddressSearchForm.vue